import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=7a566ffc&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=7a566ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a566ffc",
  null
  
)

component.options.__file = "Settings.vue"
export default component.exports